// extracted by mini-css-extract-plugin
module.exports = {"categoriesStyle":"_160VYHXSYybiFQhaTi8qoy","clientCategoriesStyle":"_17LPOdqiAHRpQz5w_aJ7-0"};